import React from 'react';
import { I18n } from 'react-redux-i18n';
import { Link } from 'react-router-dom';
import get from 'lodash/get';

import { parsePreviewArticle } from 'utils/parser';

const isMobile = window.innerWidth < 845;

const PreviewBody = ({
  id,
  content,
  is_read,
  toggleRead
}: {
  id: number;
  content: any;
  is_read: boolean;
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  toggleRead: (e: any) => void;
}) => {
  const { url, body, is_extract, is_paper, source } = content;

  const label = is_paper
    ? I18n.t('media.articleList.isPaper')
    : I18n.t('media.articleList.edited');

  const previewedArticleBody = parsePreviewArticle(body);

  return (
    <div>
      <strong>{label}</strong>
      <div className="textLimit">
        {previewedArticleBody.length > 250
          ? previewedArticleBody.substring(0, 250) + '...'
          : previewedArticleBody}
      </div>
      {!isMobile && (
        <>
          {is_extract && url ? (
            <a
              className="sourceText"
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              download
              onClick={!is_read ? () => toggleRead(id) : undefined}
            >
              {get(source, 'name')}
            </a>
          ) : (
            <Link
              to={{ pathname: `article/${id}/` }}
              className="linkArticle underline"
              onClick={() => toggleRead(id)}
            >
              {I18n.t('media.articleList.read')}
            </Link>
          )}
        </>
      )}
    </div>
  );
};

export default PreviewBody;
